function retrievePerHourPricing(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/per-hour-pricing`);
}

function updatePerHourPricing(companyId, perHourPricing) {
    return window.tenantAxios.patch(`/company/${companyId}/per-hour-pricing`, perHourPricing);
}

export default {
    retrievePerHourPricing,
    updatePerHourPricing,
};
